export default {"src":"/_next/static/media/provenir.47f54043.svg","height":24,"width":158,"blurWidth":0,"blurHeight":0};